/* eslint-disable @typescript-eslint/naming-convention */
// const api_url = "https://mpsa.oi.betaclic.com:2000/api/v1";
// const api_url = "http://54.38.183.225:22000/api/v1";

// const api_url = "http://51.178.39.156:24000/api/v1";

// Back end Pre Prod
// export const apiUrlCiv = "http://54.38.186.217:19000/api/v1";
// const api_url = "https://mpsa.oi.betaclic.com:24001/api/v1";
// const api_url = "https://mpsa.oi.betaclic.com:2000/api/v1";
// const api_url = "https://anglin.cirad.fr:9999/api/v1";
// const api_url = "https://mpsaoi.cirad.fr:9999/api/v1";
// const api_url = "https://mpsaoi.cirad.fr/api/v1";
// const api_url = "http://mpsaoi.cirad.fr:8080/api/v1";
// const api_url = "http://anglin.cirad.fr:20000/api/v1";
const api_url = "https://mpsa.sahel.betaclic.com/api/v1";
export default api_url;
